import { render, staticRenderFns } from "./ComprasHersot.vue?vue&type=template&id=37288bd3&"
import script from "./ComprasHersot.vue?vue&type=script&lang=js&"
export * from "./ComprasHersot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports